export default {
  colors: {
    dark: '#222222',
    gold: '#b00233',
    grey: '#666666',
    light: '#DDDDDD',
    white: '#FFFFFF'
  },
  font: {
    headings: "'Playfair Display', 'Georgia', 'Times New Roman', serif",
    body: "'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif"
  },

 

}


